import React from 'react'
import { Link } from "gatsby"
import {Modal} from "react-bootstrap"
import banerStyles from "./ModalBanerFix.module.scss"
import BanerImg from "../../images/600x550-orlencharge-termin3-en.jpg"
// import ModalCennik from "./ModalCennik"

function ModalBaner(props) {
  // const [modCennikShow, setModCennikShow] = React.useState(false);
    return (
      <>
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="md"
      >
        <div className="p-0">
          <Modal.Header closeButton  className={banerStyles.header}>
            <Modal.Title>Promotion</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {/* <button className="d-block m-0 p-0 w-100 border-0"
              onClick={() => {setModCennikShow(true);props.handleclose();}}
            >
              <img src={BanerImg} alt="" className="img-fluid w-100" />
            </button> */}
            <Link
                  to="/news/charge-electric-car-cheaper-with-orlen-charge"
                  title="Terms and Conditions"
                  className="d-block m-0 p-0 w-100 border-0"
                >
              <img src={BanerImg} alt="" className="img-fluid w-100" />
            </Link>
          </Modal.Body>
        </div>
      </Modal>
      {/* <ModalCennik show={modCennikShow} handleclose={() => setModCennikShow(false)} /> */}
      </>
    )
}

export default ModalBaner
